// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

export enum NboAction {
  nboCreate = "nboCreate",
  nboRead = "nboRead",
  nboUpdate = "nboUpdate",
  nboDelete = "nboDelete",
  nboValidate = "nboValidate",
  nboPublish = "nboPublish"
}

export enum NboFeature {
  nboNewsTheme,
  nboNews,
  nboSetting,
  nboKeyword,
  nboTemplate
}
